export interface MeasurementMarketAsset {
  readonly key: string;
  readonly path: string;
  readonly width: number;
  readonly height: number;
  readonly kind: 'image';
  readonly alpha: boolean;
  readonly required: true;
}

const ROOT = 'assets/number-kingdom/measurement-market';
const image = (
  key: string,
  path: string,
  width: number,
  height: number,
  alpha: boolean,
): MeasurementMarketAsset => ({ key, path: `${ROOT}/${path}`, width, height, kind: 'image', alpha, required: true });

export const MEASUREMENT_MARKET_ASSETS = {
  dormant: image('measurement-market-dormant', 'backgrounds/measurement-market-dormant.png', 1280, 720, false),
  restored: image('measurement-market-restored', 'backgrounds/measurement-market-restored.png', 1280, 720, false),
  instrument: image('measurement-market-instrument', 'interactives/royal-measuring-instrument.png', 1024, 360, true),
  ribbon: image('measurement-market-ribbon', 'interactives/royal-ribbon.png', 512, 256, true),
  rod: image('measurement-market-crystal-rod', 'interactives/crystal-rod.png', 640, 256, true),
  parcel: image('measurement-market-parcel', 'interactives/market-parcel.png', 512, 256, true),
} as const;

export const MEASUREMENT_MARKET_ASSET_LIST = Object.values(MEASUREMENT_MARKET_ASSETS);
export const MEASUREMENT_MARKET_PRODUCTION_READY = true;

export function preloadMeasurementMarketAssets(scene: Phaser.Scene) {
  MEASUREMENT_MARKET_ASSET_LIST.forEach(asset => scene.load.image(asset.key, asset.path));
}

export function getMissingMeasurementMarketAssets(textures: Phaser.Textures.TextureManager) {
  return MEASUREMENT_MARKET_ASSET_LIST.filter(asset => !textures.exists(asset.key));
}

export function canEnterMeasurementMarket(textures: Phaser.Textures.TextureManager) {
  return MEASUREMENT_MARKET_PRODUCTION_READY
    && getMissingMeasurementMarketAssets(textures).length === 0;
}
